<template>
  <div v-if="false">
    <div>{{ items.length }}</div>
    <div>Is Items Fetching: {{ isItemsFetching }}</div>
    <div>Is Order Updating: {{ isOrderUpdating }}</div>
    <div>{{ selectedItemsIds }}</div>
    <div>{{ items }}</div>
  </div>

  <div class="app-targeting-table">
    <div class="app-targeting-table__col app-targeting-table-left">
      <label class="app-targeting-table-left__search">
        <input v-model="search" type="text" placeholder="Search Targets" />
        <search-icon />
      </label>

      <slot v-if="addAllButton" name="after-label">
        <button
          :disabled="isOrderUpdating"
          class="app-targeting-table__button"
          @click="addAllItems"
        >
          Add All
        </button>
      </slot>

      <ul v-if="items.length" class="app-targeting-table-left__list">
        <li
          v-for="item in items"
          :key="item.id"
          class="app-targeting-table-left__item app-targeting-table-left-item"
          @click="addSelectedItem(item)"
        >
          <div class="app-targeting-table-left-item__text">
            {{ item.name }}
          </div>
          <plus-icon />
        </li>
        <p v-if="isItemsFetching">Loading...</p>
        <div
          v-else
          class="intersection-observer"
          ref="intersectionTarget"
          v-intersection-observer="onIntersectionObserver"
        ></div>
      </ul>
    </div>

    <div class="app-targeting-table__col app-targeting-table-right">
      <template v-if="singleItem && selectedItems.length === 0">
        <p class="app-targeting-table__no-items">
          Select the item from the left side
        </p>
      </template>
      <div v-if="!singleItem" class="app-targeting-table-right__selected">
        <div class="app-targeting-table-right__left">
          <span class="app-targeting-table-right__text">Items selected:</span>
          <span class="app-targeting-table-right__count"
            >{{ selectedItems.length }}
          </span>
        </div>
        <button
          @click="removeAllSelectedItems"
          class="app-targeting-table-right__text"
        >
          Remove all
        </button>
      </div>
      <ul class="app-targeting-table-right__list">
        <li
          v-for="selectedItem in selectedItems"
          :key="selectedItem.id"
          class="app-targeting-table-right__item app-targeting-table-right-item"
          @click="removeSelectedItem(selectedItem)"
        >
          <div class="app-targeting-table-right-item__text">
            {{ selectedItem.name }}
            {{ selectedItem.selectedItemPosition }}
          </div>
          <minus-icon />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import SearchIcon from '@/assets/svg/search.svg?component'
import PlusIcon from '@/assets/svg/plus.svg?component'
import MinusIcon from '@/assets/svg/minus.svg?component'

import { defineProps } from 'vue'
import { vIntersectionObserver } from '@vueuse/components'
import { useTargetingList } from './useTargetingList'

const props = defineProps({
  resourceUrl: {
    type: String,
    required: true,
  },
  singleItem: {
    type: Boolean,
    default: false,
  },
  payloadKeyName: {
    type: String,
    required: true,
  },
  restrictSelection: {
    type: Boolean,
    default: true,
  },
  selectedItems: {
    type: Array,
    default: () => [],
  },
  addAllButton: {
    type: Boolean,
    default: false,
  },
})

const {
  search,
  items,
  isItemsFetching,
  selectedItems,
  selectedItemsIds,
  addSelectedItem,
  removeSelectedItem,
  removeAllSelectedItems,
  addAllItems,
  onIntersectionObserver,
  isOrderUpdating,
} = useTargetingList(props)
</script>
